/* global zE, $zopim */

'use strict';

var zendeskUtil = require('./zendeskUtil.js');
const keyPart = 'conversationStartedAt';
const chatStartedTime = 'conversationStartedByUserDateTime';
const strChatWidgetShow = 'zeWidget:show';
const strChatWidgetHide = 'zeWidget:hide';
const strZendeskOpen = 'zendesk:open';
const strStartChat = 'chat:start_chat';
const strSetmessenger = 'messenger:set';
const strSetmessengerOn = 'messenger:on';
const strWebWidgetOn = 'webWidget:on';
const strQuestionMark = '.js-question-mark';
const strEmeaHelpModal = '#emeaHelpModal';
var zeHelp;

/**
* Checks if Zendesk widget is loaded and a chat is in progress.
* @returns {boolean} - Returns true if the widget is loaded and a chat is in progress, otherwise false.
*/
function isZendeskIntiated() {
    if (zeHelp) {
        // New widget: check sessionStorage for chat session
        for (let i = 0; i < sessionStorage.length; i += 1) {
            let key = sessionStorage.key(i);
            if (key.includes(keyPart)) {
                return sessionStorage.getItem(key);
            }
        }
        return null;
    }
    // Old widget: use $zopim API
    return $zopim && $zopim.livechat && $zopim.livechat.isChatting();
}

/**
 * Checks if a Zendesk chat session is currently active based on stored time and session duration.
 * @returns {boolean|number} Returns the remaining time in minutes if a chat session is active,
 * otherwise returns false if no active chat session is detected.
 */
function checkTime() {
    const storedTime = localStorage.getItem(chatStartedTime);
    const customChatSessionTime = document.getElementById('zendeskPrefs').dataset.zeChatSession;
    if (storedTime !== null) {
        const currentTime = new Date().getTime();
        const storedTimeMs = parseInt(storedTime, 10);
        const timeDiffInMinutes = Math.floor((currentTime - storedTimeMs) / 60000);
        return timeDiffInMinutes < customChatSessionTime ? customChatSessionTime : 0;
    }
    return false;
}

/**
* Verifies whether the new chat feature is enabled and subsequently hides the default web widget.
* @returns {void}
*/
var zeHideWidget = function () {
    if (zeHelp) {
        zE('messenger', 'hide');
        zE('messenger', 'close');
        $(strQuestionMark).show();
    }
};

/**
* Shows and opens the Zendesk widget.
* @returns {void}
*/
var zeShowWidget = function () {
    $(strQuestionMark).hide();
    if (zeHelp) {
        zE('messenger', 'show');
        zE('messenger', 'open');
    } else {
        zE('webWidget', 'show');
        zE('webWidget', 'open');
    }
    $(document).trigger(strZendeskOpen);
    // ZENDESK ANALYTICS EVENT
    $(document).trigger(strStartChat);
};

/**
* Handel custom chat button click event.
* @returns {void}
*/
var handelCustomChatButtonClick = function () {
    if (checkTime() && isZendeskIntiated()) {
        $(document).trigger(strChatWidgetShow);
        // ZENDESK ANALYTICS EVENT
        $(document).trigger('chat:start_chat');
    } else {
        $(strEmeaHelpModal).modal('toggle');
        $(document).trigger('chat:open_modal');
    }
};

/**
 * Sets the locale for Zendesk widgets.
 * @param {string} Locale - The locale string.
 * @returns {void}
 */
function setLocaleAndFields(Locale) {
    var zeLocale = Locale;
    // TO BE REVIEWED: THIS IS NOT MANDATORY AS THE WIDGET WILL LOCALIZE BASED ON THE
    // BROWSER LANGUAGE: source: https://developer.zendesk.com/api-reference/widget-
    // messaging / web / core / #set - locale
    zeLocale = zeLocale === 'en_GB'
        || zeLocale === 'fr_CA'
        || zeLocale === 'zh_HK'
        || zeLocale === 'zh_TW' ? zeLocale : zeLocale.substring(0, 2);
    if (['en', 'de', 'fr', 'es', 'it', 'nl', 'pt', 'en_GB', 'fr_CA', 'zh_HK', 'zh_TW'].indexOf(zeLocale) > -1) {
        // convert locale to zopim format
        var zopimChatLocale = zeLocale.toLowerCase().replace('_', '-');
        if (zeHelp) {
            zE(strSetmessenger, 'locale', zopimChatLocale);
        } else {
            zE.setLocale(zopimChatLocale);
        }
    }
}

/**
 * Binds events and sets zIndex for the new Zendesk Messaging widget.
 * @param {string} zeLocale - The locale string.
 * @returns {void}
 */
function bindNewWidgetEvents(zeLocale) {
    zE(strSetmessenger, 'zIndex', 3);
    zE(strSetmessengerOn, 'open', function () {
        zE('messenger', 'show');
        zE('messenger', 'open');
        $(document).trigger(strZendeskOpen);
        $(strQuestionMark).hide();
        zE(strSetmessenger, 'zIndex', 999999);
    });

    zE(strSetmessengerOn, 'close', function () {
        $(document).trigger(strChatWidgetHide, { zeHelp });
        zE(strSetmessenger, 'zIndex', 3);
    });

    $('.js-needhelp-emea-na').on('click', function () {
        const currentTime = new Date().getTime();
        localStorage.setItem(chatStartedTime, currentTime);
        $(strEmeaHelpModal).modal('toggle');
        $(document).trigger(strChatWidgetShow);
    });

    var setMarket = zeLocale;
    if (setMarket && setMarket.includes('_')) {
        setMarket = setMarket.replace('_', '-').toLowerCase();
    }
    zE(strSetmessenger, 'conversationFields', [{
        id: '18484993183644',
        value: setMarket || ''
    }]);

    setLocaleAndFields(zeLocale);

    zE(strSetmessenger, 'zIndex', 3);
    // show the widget
    zE('messenger', zeHelp ? 'hide' : 'show');
}

/**
 * Binds events and sets zIndex for the old Zendesk Web Widget.
 * @param {string} zeLocale - The locale string.
 * @param {string} zeVisitorDept - The visitor department string.
 * @returns {void}
 */
function bindOldWidgetEvents(zeLocale, zeVisitorDept) {
    zE(strWebWidgetOn, 'open', function () {
        $(document).trigger(strZendeskOpen);
        zE('webWidget', 'updateSettings', {
            webWidget: {
                zIndex: 999999
            }
        });
    });

    zE(strWebWidgetOn, 'close', function () {
        $(document).trigger(strChatWidgetHide, { zeHelp });
        zE('webWidget', 'updateSettings', {
            webWidget: {
                zIndex: 3
            }
        });
    });
    // This event is added because when the chat is opened in a new window, it triggers the rendering of the default chat button.
    zE(strWebWidgetOn, 'chat:popout', function () {
        $(document).trigger(strChatWidgetHide, { zeHelp });
    });
    $('.js-needhelp-emea-na').on('click', function () {
        $(strEmeaHelpModal).modal('toggle');
        $(document).trigger(strChatWidgetShow);
    });

    zE(function () {
        setLocaleAndFields(zeLocale);
        zE('webWidget', 'updateSettings', { // To make sure the zendesk icon doesn't overlap with filters or paypal checkout
            webWidget: {
                zIndex: 3 // translates to z-index : 2 in CSS for some reason
            }
        });
        // show the widget
        if (zeHelp) {
            zE.hide();
        } else {
            zE.show();
        }
        // $zopim function below never gets activated, this timeout removes loading icon from chat widgets clicked
        // TODO - zendesk code here is Legacy v1 API - update to command syntax for more flexibility
        // https://developer.zendesk.com/embeddables/docs/widget/api

        // Only run $zopim code if $zopim is defined
        if (typeof $zopim === 'function') {
            $zopim(function () {
                // set the department if site pref set
                if (zeVisitorDept !== 'null') {
                    $zopim.livechat.departments.filter('');
                    $zopim.livechat.departments.setVisitorDepartment(zeVisitorDept);
                    $zopim.livechat.setOnConnected(function () {
                        var deptStatus = $zopim.livechat.departments.getDepartment(zeVisitorDept);
                        if (deptStatus.status === 'offline') {
                            // Set the account status to 'offline' and hide widget
                            $zopim.livechat.setStatus('offline');
                            $zopim.livechat.hideAll();
                        } else {
                            // The department is Online (At least one agent in that dept is Online)
                            // Automatically add a tag
                            // Adding a tag is completely optional. It can help with reporting in support
                            $zopim.livechat.addTags('new_balance_chat');
                            // set the Department
                            $zopim.livechat.departments.filter('');
                            $zopim.livechat.departments.setVisitorDepartment(zeVisitorDept);
                        }
                    });
                }
            });
        }
    });
}

/**
* Set locale and department if available. Activate Zendesk widget
* @param {HTMLElement} zElement - Div holding Zendesk site preference data
*/
function activateZendesk(zElement) {
    var zeVisitorDept = zElement.dataset.zeVisitorDept;
    var zeLocale = zElement.dataset.zeLocale;
    if (zeHelp) {
        bindNewWidgetEvents(zeLocale);
    } else {
        bindOldWidgetEvents(zeLocale, zeVisitorDept);
    }
}

/**
* Initiate Zendesk widget if enabled in site preferences
* @param {HTMLElement} zElement - Div holding Zendesk site preference data
*/
function initiateZendesk(zElement) {
    zendeskUtil.initiateZendeskScript(zElement);
    activateZendesk(zElement);
}

module.exports = {
    init: function () {
        var zendeskPrefs = document.getElementById('zendeskPrefs');
        var zendeskDataset = zendeskPrefs && zendeskPrefs.dataset;
        zeHelp = zendeskDataset && zendeskDataset.zeHelp === 'true';
        if (zendeskPrefs) {
            // Pass in element containing data attributes needed to run Zendesk widget
            initiateZendesk(zendeskPrefs);
            $('.js-question-mark, a[href="#jsLiveChat"]').on(
                'click',
                handelCustomChatButtonClick
            );
            $(document).on(strChatWidgetShow, zeShowWidget);
            $(document).on(strChatWidgetHide, zeHideWidget);
        }
    }
};
